import {
  createRole,
  updateRole,
  deleteRole,
  queryRoleList,
  queryMenuListByRole,
  bindRoleResource
} from "@/graphql/roleManager.gql";
import { filterNodeData } from "@root/lib/utils";

function arrayFlat(arr, result, label) {
  arr.forEach(el => {
    if (el[label]) {
      result.push(el);
      return arrayFlat(el[label], result, label);
    } else {
      result.push(el);
    }
  });
  return result;
}
export default {
  namespaced: true,
  state: {
    dataList: []
  },
  getters: {},
  actions: {
    async getRoleList({ rootState, commit }, data) {
      let {
        data: {
          res: {
            dataList,
            pageInfo: { totalCount: total }
          }
        }
      } = await rootState.gql.query({
        query: queryRoleList,
        variables: data
      });
      commit("setDataList", dataList);
      return { total, dataList };
    },
    async getMenuListByRole({ rootState, commit }, data) {
      let res = await rootState.gql.query({
        query: queryMenuListByRole,
        variables: data
      });
      return res.data.res;
    },
    async addRole({ rootState, commit }, data) {
      await rootState.gql.mutate({
        mutation: createRole,
        variables: data
      });
    },
    async updateRole({ rootState, commit }, data) {
      await rootState.gql.mutate({
        mutation: updateRole,
        variables: data
      });
    },

    async deleteRole({ commit, state, rootState }: any, data) {
      await rootState.gql.mutate({
        mutation: deleteRole,
        variables: data
      });
    },
    async bindRoleResource({ commit, state, rootState }: any, data) {
      await rootState.gql.mutate({
        mutation: bindRoleResource,
        variables: data
      });
    }
  },
  mutations: {
    setDataList(state, data) {
      let res = filterNodeData(data);
      let flatRes = res.map(({ list, ...others }) => {
        let l = arrayFlat(list, [], "children");
        return {
          ...others,
          resource: l,
          resourceStr: l.map(i => i.menuName).join(",")
        };
      });
      state.dataList = flatRes;
    }
  }
};
